import React, { useEffect, useState } from "react";
import ThemeAddButton from "../components/ThemeComponent/ThemeAddButton";
import Table from "../components/ThemeComponent/ThemeDataTable";
import ThemePagination from "../components/ThemeComponent/ThemePagination";
import ThemeSearchInput from "../components/ThemeComponent/ThemeSearchInput";
import { PageHeading } from "../components/ThemeComponent/ThemeText";
import { errorToast, formatDate, success } from "../utils/helpers.js";
import ThemeModal from "../components/ThemeComponent/ThemeModal";
import AddNewTask from "../components/modals/AddNewTask";
import {
  useCompletionStatusMutation,
  useDeletetaskMutation,
  useGettasksQuery,
} from "../Redux/services/ClientAPis/taskApi";
import RemoveModal from "../components/modals/RemoveModal";
import { useSelector } from "react-redux";
import OperationTheater from "../components/modals/OperationTheater";
const TaskManagement = () => {
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [removeOpen, setRemoveOpen] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [modalData, setModalData] = useState(null);
  const [taskModal, setTaskModal] = useState(false);
  const [taskView, setTaskView] = useState(false);
  const [taskModalData, setTaskModalData] = useState(null);

  const user = useSelector((state) => state.authInfo.user);

  const { data, isSuccess, isLoading, isFetching, refetch } = useGettasksQuery(
    {
      search: searchQuery.length >= 3 ? searchQuery : "",
      limit: pageSize,
      page: page,
      user_role: user?.user_type === "STAFF" ? "staff" : "client",
    },
    { refetchOnMountOrArgChange: true }
  );
  const [deletetask, { isLoading: deleteLoading }] = useDeletetaskMutation();
  const [completionStatus, { isLoading: completionLoading }] =
    useCompletionStatusMutation();

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setPage(data.links.current);
      setTotalRecords(data.links.total_records === 0 ? '' : data.links.total_records);
      setTotalPages(data.links.total);
      // setRowData(data.data);
    }
  }, [data]);

  const onRemoveClick = async () => {
    await deletetask({ id: modalData.id });
    setTimeout(() => {
      setRemoveOpen(false);
      success("Successfully Removed");
      refetch();
    }, 500);
  };

  const onSubmit = async (data) => {
    const payload = { id: data?.id };
    try {
      let response = await completionStatus(payload);

      if (response.data.code === 200) {
        refetch();
        success(response?.data?.message);
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        errorToast(error?.response?.data?.message, "error");
      }
    }
  };

  const header = [
    {
      title: "Task Title",
      dataIndex: "title",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData) => {
        return (
          <div
            className="cursor"
            onClick={() => { setTaskView(true); setTaskModalData(rowData); }}
            style={{ textDecoration: "none" }}
            onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
            onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
          >
            {rowData?.title}
          </div>
        );
      },
    },
    {
      title: "Assign Date",
      dataIndex: "assigned_date",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <div>{formatDate(rowData?.assign_date)}</div>;
      },
    },
    {
      title: "Assigned By",
      dataIndex: "assigned_by",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <div>{rowData?.client?.name}</div>;
      },
    },
    {
      title: "Assigned To",
      dataIndex: "assigned_to",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <div>{rowData?.staff?.name}</div>;
      },
    },
    {
      title: "Notes",
      dataIndex: "description",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
    },
    {
      title: "Completion Date ",
      dataIndex: "completion_date",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData, index) => {
        return <div>{formatDate(rowData?.completion_date)}</div>;
      },
    },
    {
      title: "Status ",
      dataIndex: "Status ",
      style: { textAlign: "left" },
      elementStyle: { textAlign: "left", width: "180px", minWidth: "200px" },
      render: (_, rowData) => {
        return rowData.status == 20 ? (
          <div className="completed_status flex-custom-center">Completed</div>
        ) : (
          <div className="pending_status flex-custom-center"> Pending</div>
        );
      },
    },
  ];

  // const data = [
  //   {
  //     slug: 1,
  //     client_name: "Cameron Williamson",
  //     phone: "(603) 555-0123",
  //     email: "nathan.roberts@example.com",
  //     designation: "Physician",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     assigned_by: "Dr. Smith",
  //     assigned_to: "Dr. Johnson",
  //     assigned_date: "Jun 1, 2024",
  //     completion_date: "Jun 5, 2024",
  //   },
  //   {
  //     slug: 2,
  //     client_name: "Floyd Miles",
  //     phone: "(209) 555-0104",
  //     email: "debbie.baker@example.com",
  //     designation: "Surgeon",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     assigned_by: "Dr. Taylor",
  //     assigned_to: "Dr. Anderson",
  //     assigned_date: "Jun 2, 2024",
  //     completion_date: "Jun 6, 2024",
  //   },
  //   {
  //     slug: 3,
  //     client_name: "Annette Black",
  //     phone: "(704) 555-0127",
  //     email: "debbie.lawson@example.com",
  //     designation: "Radiologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     assigned_by: "Dr. Martinez",
  //     assigned_to: "Dr. Lee",
  //     assigned_date: "Jun 3, 2024",
  //     completion_date: "Jun 7, 2024",
  //   },
  //   {
  //     slug: 4,
  //     client_name: "Theresa Webb",
  //     phone: "(808) 555-0111",
  //     email: "novah.simmons@example.com",
  //     designation: "Neurologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     assigned_by: "Dr. Brown",
  //     assigned_to: "Dr. Walker",
  //     assigned_date: "Jun 4, 2024",
  //     completion_date: "Jun 8, 2024",
  //   },
  //   {
  //     slug: 5,
  //     client_name: "Kathryn Murphy",
  //     phone: "(307) 555-0133",
  //     email: "jessica.hanson@example.com",
  //     designation: "Physiotherapist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     assigned_by: "Dr. Green",
  //     assigned_to: "Dr. Davis",
  //     assigned_date: "Jun 5, 2024",
  //     completion_date: "Jun 9, 2024",
  //   },
  //   {
  //     slug: 6,
  //     client_name: "Brooklyn Simmons",
  //     phone: "(702) 555-0122",
  //     email: "felicia.reid@example.com",
  //     designation: "Pediatrician",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     assigned_by: "Dr. Harris",
  //     assigned_to: "Dr. Carter",
  //     assigned_date: "Jun 6, 2024",
  //     completion_date: "Jun 10, 2024",
  //   },
  //   {
  //     slug: 7,
  //     client_name: "Robert Fox",
  //     phone: "(252) 555-0125",
  //     email: "tim.jennings@example.com",
  //     designation: "Gynecologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     assigned_by: "Dr. Hall",
  //     assigned_to: "Dr. White",
  //     assigned_date: "Jun 7, 2024",
  //     completion_date: "Jun 11, 2024",
  //   },
  //   {
  //     slug: 8,
  //     client_name: "Dianne Russell",
  //     phone: "(201) 555-0124",
  //     email: "curtis.weaver@example.com",
  //     designation: "Anesthesiologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     assigned_by: "Dr. Young",
  //     assigned_to: "Dr. King",
  //     assigned_date: "Jun 8, 2024",
  //     completion_date: "Jun 12, 2024",
  //   },
  //   {
  //     slug: 9,
  //     client_name: "Leslie Alexander",
  //     phone: "(319) 555-0115",
  //     email: "michelle.rivera@example.com",
  //     designation: "Pathologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     assigned_by: "Dr. Wright",
  //     assigned_to: "Dr. Lopez",
  //     assigned_date: "Jun 9, 2024",
  //     completion_date: "Jun 13, 2024",
  //   },
  //   {
  //     slug: 10,
  //     client_name: "Devon Lane",
  //     phone: "(207) 555-0119",
  //     email: "dolores.chambers@example.com",
  //     designation: "Oncologist",
  //     date: "2020-01-02",
  //     checkIn: "18:05:57",
  //     checkOut: "22:05:57",
  //     notes: "Lorem ipsum dolor sit amet.",
  //     assigned_by: "Dr. Hill",
  //     assigned_to: "Dr. Scott",
  //     assigned_date: "Jun 10, 2024",
  //     completion_date: "Jun 14, 2024",
  //   },
  // ];

  const handleDownloadCLick = () => {
    setDownloadLoading(true);
    setTimeout(() => {
      setDownloadLoading(false);
      success("Successfully Downloaded");
    }, 1500);
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1500);
  }, [page]);

  return (
    <div className="dashboard-page patient-page">
      <div className="header d-flex justify-content-between">
        <PageHeading text={"Task Management"} count={totalRecords} />
        <div className="d-flex responsive-flex align-items-center gap-3">
          {user?.user_type === "CLIENT" && (
            <ThemeAddButton
              text={"Add Task"}
              onClick={() => setAddOpen(true)}
              className={"responsive-margin"}
            />
          )}
          <ThemeSearchInput setSearchQuery={setSearchQuery} />
        </div>
      </div>
      <div className="table-content mt-2">
        <Table
          header={header}
          data={data?.data}
          loading={isLoading}
          removeText="Task"
          onEditClick={() => setShowEdit(true)}
          setModalData={setModalData}
          setRemoveOpen={() => setRemoveOpen(true)}
          isAction={user?.user_type === "CLIENT"}
          taskModal={taskModal}
          setTaskModal={setTaskModal}
          taskUpdate={user?.user_type === "STAFF"}
          statusUpdate={onSubmit}
        />
      </div>
      <div className="pagination mt-3">
        {/* {!loading && ( */}
          <ThemePagination
            activePage={page}
            totalPages={totalPages}
            setPage={setPage}
            page={page}
          />
        {/* )} */}
      </div>
      {addOpen && (
        <ThemeModal
          size={"xl"}
          modalContent={<AddNewTask setIsOpen={setAddOpen} refetch={refetch} />}
          title={"Add New Task"}
          className={"edit-profile"}
          isOpen={addOpen}
          setIsOpen={setAddOpen}
        />
      )}
      {showEdit && (
        <ThemeModal
          size={"xl"}
          modalContent={
            <AddNewTask
              setIsOpen={setShowEdit}
              modalData={modalData}
              refetch={refetch}
            />
          }
          title={"Update Task"}
          className={"edit-profile"}
          isOpen={showEdit}
          setIsOpen={setShowEdit}
        />
      )}
      {removeOpen && (
        <ThemeModal
          size={"sm"}
          modalContent={
            <RemoveModal
              setIsOpen={setRemoveOpen}
              modalData={modalData}
              refetch={refetch}
              onRemoveClick={onRemoveClick}
              isLoading={deleteLoading}
            />
          }
          title={""}
          className={"edit-profile"}
          isOpen={removeOpen}
          setIsOpen={setRemoveOpen}
        />
      )}
      {taskView && (
        <ThemeModal
          size={"lg"}
          modalContent={<OperationTheater setIsOpen={setTaskView} modalData={taskModalData} />}
          className={"edit-profile"}
          isOpen={taskView}
          setIsOpen={setTaskView}
        />
      )}
    </div>
  );
};

export default TaskManagement;
